// Quiz parent component
if (!customElements.get('component-video')) {
  customElements.define('component-video', class Video extends HTMLElement {
    constructor() {
      super();
      this.props = {
        autoplay: this.dataset.autoplay === 'true',
        posterDesktop: this.dataset.posterDesktop,
        videoDesktop: this.dataset.videoDesktop,
        posterMobile: this.dataset.posterMobile,
        videoMobile: this.dataset.videoMobile
      }
      this.state = {
        isMobile: window.innerWidth <= 768
      }
      this.handleResize = this.handleResize.bind(this);
    }
    connectedCallback() {
      this.video = this.querySelector('.js-video');
      this.loadVideo();
      window.addEventListener('resize', this.handleResize);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }
    handleResize() {
      const currentIsMobile = window.innerWidth <= 768;
      if (this.state.isMobile !== currentIsMobile) {
        this.state.isMobile = currentIsMobile;
        this.loadVideo();
      }
    }
    loadVideo() {
      const video = this.video;
      if (video) {
        if (this.state.isMobile) {
          if (this.props.posterMobile) video.poster = this.props.posterMobile;
          if (this.props.videoMobile) video.querySelector('.js-source').src = this.props.videoMobile;
        } else {
          if (this.props.posterDesktop) video.poster = this.props.posterDesktop;
          if (this.props.videoDesktop) video.querySelector('.js-source').src = this.props.videoDesktop;
        }
        video.autoplay = this.props.autoplay;
        video.defaultMuted = this.props.autoplay;
        video.muted = this.props.autoplay;
        video.load();
        video.onloadeddata = () => {
          if (!this.props.autoplay) return;
          video.defaultMuted = true;
          video.muted = true;
          video.play().catch(() => {});
        };
      }
    }
  });
}
